var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-[312px] p-300 bg-[#f0f3f7]"},[_c('div',{staticClass:"h-px bg-[#646D7D] opacity-20 mb-300"}),_vm._v(" "),_c('ProjectsPanelAllProjectsNavItem',{staticClass:"mb-2"}),_vm._v(" "),_c('ProjectsPanelTemplateNavItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }